"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
exports.__esModule = true;
exports.createHandlerSetter = exports.useDeepCompareEffect = exports.useNetwork = exports.useLongPress = exports.useSize = exports.useRafState = exports.useLatest = exports.useControlValue = exports.useUpdate = exports.useMemoizedFn = exports.requestApply = exports.useRequest = exports.useInput = exports.useToggle = exports.useThrottled = exports.useDebounced = exports.useInterval = exports.useTimeout = exports.useURLSearchParams = exports.useValueHistory = exports.useSet = exports.useMap = exports.useObject = exports.useSessionStorageState = exports.usePreviousValue = exports.useSessionStorage = exports.useLocalStorage = exports.useCookie = exports.useStorage = exports.useDocumentVisibility = exports.useScript = exports.useCss = exports.useInfiniteScroll = exports.useResizeObserver = exports.useGlobalEvent = exports.useWindowScroll = exports.useWindowResize = exports.useEvent = exports.useDidUpdate = exports.useIsFirstRender = exports.useLifecycle = exports.useWillUnmount = exports.useDidMount = void 0;
// 1、lifeCycle(生命周期类型)
var useDidMount_1 = require("./useDidMount");
__createBinding(exports, useDidMount_1, "default", "useDidMount");
var useWillUnmount_1 = require("./useWillUnmount");
__createBinding(exports, useWillUnmount_1, "default", "useWillUnmount");
var useLifecycle_1 = require("./useLifecycle");
__createBinding(exports, useLifecycle_1, "default", "useLifecycle");
var useIsFirstRender_1 = require("./useIsFirstRender");
__createBinding(exports, useIsFirstRender_1, "default", "useIsFirstRender");
var useDidUpdate_1 = require("./useDidUpdate");
__createBinding(exports, useDidUpdate_1, "default", "useDidUpdate");
// 2、DOM
var useEvent_1 = require("./useEvent");
__createBinding(exports, useEvent_1, "default", "useEvent");
var useWindowResize_1 = require("./useWindowResize");
__createBinding(exports, useWindowResize_1, "default", "useWindowResize");
var useWindowScroll_1 = require("./useWindowScroll");
__createBinding(exports, useWindowScroll_1, "default", "useWindowScroll");
var useGlobalEvent_1 = require("./useGlobalEvent");
__createBinding(exports, useGlobalEvent_1, "default", "useGlobalEvent");
var useResizeObserver_1 = require("./useResizeObserver");
__createBinding(exports, useResizeObserver_1, "default", "useResizeObserver");
var useInfiniteScroll_1 = require("./useInfiniteScroll");
__createBinding(exports, useInfiniteScroll_1, "default", "useInfiniteScroll");
var useCss_1 = require("./useCss");
__createBinding(exports, useCss_1, "default", "useCss");
var useScript_1 = require("./useScript");
__createBinding(exports, useScript_1, "default", "useScript");
var useDocumentVisibility_1 = require("./useDocumentVisibility");
__createBinding(exports, useDocumentVisibility_1, "default", "useDocumentVisibility");
// 3、storage
var createStorageHook_1 = require("./factory/createStorageHook");
__createBinding(exports, createStorageHook_1, "default", "useStorage");
var useCookie_1 = require("./useCookie");
__createBinding(exports, useCookie_1, "default", "useCookie");
var useLocalStorage_1 = require("./useLocalStorage");
__createBinding(exports, useLocalStorage_1, "default", "useLocalStorage");
var useSessionStorage_1 = require("./useSessionStorage");
__createBinding(exports, useSessionStorage_1, "default", "useSessionStorage");
var usePreviousValue_1 = require("./usePreviousValue");
__createBinding(exports, usePreviousValue_1, "default", "usePreviousValue");
var useSessionStorage_2 = require("./useSessionStorage");
__createBinding(exports, useSessionStorage_2, "default", "useSessionStorageState");
// 4、state
var useObject_1 = require("./useObject");
__createBinding(exports, useObject_1, "default", "useObject");
var useMap_1 = require("./useMap");
__createBinding(exports, useMap_1, "default", "useMap");
var useSet_1 = require("./useSet");
__createBinding(exports, useSet_1, "default", "useSet");
var useValueHistory_1 = require("./useValueHistory");
__createBinding(exports, useValueHistory_1, "default", "useValueHistory");
var useURLSearchParams_1 = require("./useURLSearchParams");
__createBinding(exports, useURLSearchParams_1, "default", "useURLSearchParams");
// 5、advanced 高级类的
var useTimeout_1 = require("./useTimeout");
__createBinding(exports, useTimeout_1, "default", "useTimeout");
var useInterval_1 = require("./useInterval");
__createBinding(exports, useInterval_1, "default", "useInterval");
var useDebounced_1 = require("./useDebounced");
__createBinding(exports, useDebounced_1, "default", "useDebounced");
var useThrottled_1 = require("./useThrottled");
__createBinding(exports, useThrottled_1, "default", "useThrottled");
// 6、form
var useToggle_1 = require("./useToggle");
__createBinding(exports, useToggle_1, "default", "useToggle");
var useInput_1 = require("./useInput");
__createBinding(exports, useInput_1, "default", "useInput");
var useRequest_1 = require("./useRequest");
__createBinding(exports, useRequest_1, "default", "useRequest");
__createBinding(exports, useRequest_1, "requestApply");
var useMemoizedFn_1 = require("./useMemoizedFn");
__createBinding(exports, useMemoizedFn_1, "default", "useMemoizedFn");
var useUpdate_1 = require("./useUpdate");
__createBinding(exports, useUpdate_1, "default", "useUpdate");
var useControlValue_1 = require("./useControlValue");
__createBinding(exports, useControlValue_1, "default", "useControlValue");
var useLatest_1 = require("./useLatest");
__createBinding(exports, useLatest_1, "default", "useLatest");
// keep it just for compatibility issues
var useRafState_1 = require("./useRafState");
__createBinding(exports, useRafState_1, "default", "useRafState");
var useSize_1 = require("./useSize");
__createBinding(exports, useSize_1, "default", "useSize");
var useLongPress_1 = require("./useLongPress");
__createBinding(exports, useLongPress_1, "default", "useLongPress");
var useNetwork_1 = require("./useNetwork");
__createBinding(exports, useNetwork_1, "default", "useNetwork");
var useDeepCompareEffect_1 = require("./useDeepCompareEffect");
__createBinding(exports, useDeepCompareEffect_1, "default", "useDeepCompareEffect");
var createHandlerSetter_1 = require("./factory/createHandlerSetter");
__createBinding(exports, createHandlerSetter_1, "default", "createHandlerSetter");